import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

// Layered bot traps for public forms: an invisible honeypot field bots auto-fill, plus a
// SERVER-minted signed time-to-submit stamp (fetched on mount) so client clock skew can
// never block a real user. Both travel as headers and are verified server-side.
export function useBotTrap() {
  const stampRef = useRef("");
  const hpRef = useRef(null);
  useEffect(() => {
    api.get("/form-stamp").then((r) => { stampRef.current = r.data?.stamp || ""; }).catch(() => {});
  }, []);
  const trapHeaders = () => ({ "x-form-ts": stampRef.current, "x-hp": hpRef.current?.value || "" });
  const honeypot = (
    <div aria-hidden="true" style={{ position: "absolute", left: "-9999px", height: 0, width: 0, overflow: "hidden" }}>
      <label>
        Leave this field empty
        <input ref={hpRef} type="text" name="xf_note" tabIndex={-1} autoComplete="off"
          data-lpignore="true" data-1p-ignore="true" data-form-type="other" />
      </label>
    </div>
  );
  return { honeypot, trapHeaders };
}
